import { waLink } from './contacto';
// La página final, a lo Hormozi (spec v4, «La página final», An 03/11/2026): por producto, la oferta
// apilada — resultado soñado (el mensaje del nodo de resultado) · qué te llevás · garantía · escasez ·
// precio · un solo botón al contacto.
// Solo material escrito por An en la memoria. Donde no hay oferta escrita, el campo va en `null` y la
// página no lo muestra (An, 04/11: nada de notas internas a la vista): nada se inventa. `puente` cierra la muestra gratis («Probalo hoy»)
// y lleva a la oferta: a mano sale una vez; con el producto, una estrategia estable para escalar (An, 04/11).
// Fuentes: guia-memory/guia-propio/oferta-de-productos.md §20A (ficha v2), §15c y §15e ·
// guia-propio/talleres-ia/README.md (decisiones firmes) · seguimiento (Claudia, agente administrativa).
// 🟠 Garantía, cohorte, fechas y precio: los confirma An antes de publicar (spec v4).
// 🔴 Los niveles se muestran como planes (An, 04/11: «Agencia Inicial no queda bien. Vamos a pausar esos nombres
// por ahora. Agencia ya es suficiente. Pueden ser planes»). Las claves internas siguen siendo INICIAL ·
// ASISTENCIA · ENERGIA (planes.js y la medición); en pantalla va PLAN[nivel].
export const PLAN = { INICIAL: 'Plan Inicial', ASISTENCIA: 'Plan Asistencia', ENERGIA: 'Plan Energía' };

// Orientadas a conversión, a lo Hormozi (An, 04/11: «orientá a conversión todas las ofertas, hormozizealas»):
// resultado soñado con plazo arriba · qué te llevás dicho como resultado · lo que hacemos nosotros (menos
// esfuerzo tuyo) · garantía solo donde An la definió · dos salidas: postularse y esperar el mensaje, o agendar una
// llamada para sacarse dudas (An, 04/11). Precios: ninguno definido todavía. 🟠 Lo reescrito es mío, a validar.
// Agencia: una oferta por nivel. El nivel lo sugiere el tamaño del equipo (planes.js).
const NIVELES = {
  INICIAL: {
    titulo: 'Agencia · Plan Inicial',
    bajada: 'Tu punto de partida seguro con IA.', // An, 04/11 (aprobó la reescritura desde el resultado)
    incluye: [ // §15e, «InicIAl = la base que se compra online y se instala sola»
      'Desde el primer día conoce tu empresa: cómo habla, dónde están las cosas y qué no se toca',
      'Seis trabajos resueltos desde la primera semana: la semana armada, el mail, las cobranzas, los presupuestos, las reseñas y las publicaciones',
      'Todo sale con tu marca',
      'Sin trabajo técnico de tu lado: se instala sola y la sesión de instalación es gratis',
    ],
    garantia: null,
    escasez: null,
    precio: null, // §15b: «fijo (sin definir)»
    boton: 'Quiero postularme', // An, 04/11: «ya postularse y esperar mi contacto»
  },
  ASISTENCIA: {
    titulo: 'Agencia · Plan Asistencia', // la cohorte fundadora va en su propio bloque (cohorte)
    bajada: 'Tu equipo trabajando con IA en 30 días.', // An, 04/11; los 30 días son de §17b
    incluye: [ // §20A, cortos (04/11, «está llena de palabras»)
      'Hasta 5 puestos con su tarea armada por nosotros',
      'Tu equipo capacitado en sus tareas',
      'Lo que sabe cada uno, escrito en la empresa',
      // 🟠 «tiempo liberado» suma a la medición la cuenta de la calculadora: hoy el informe del día 30 no la calcula.
      'A los 30 días, la medición: quién la usa y cuánto tiempo liberó',
    ],
    garantia: null, // va dentro de la cohorte
    escasez: null,
    // La cohorte fundadora como algo limitado (An, 04/11: «debería presentarse como algo limitado, no la veo
    // delicious»): cinco lugares, lo que gana quien entra y lo que se pide a cambio, con el botón ahí mismo.
    // No se marcan lugares ocupados: no hay datos reales. Fechas de An (04/11): inscripción hasta el 18/11,
    // arranca el 25/11. Vence sola: pasado el cierre la cohorte desaparece, nunca una vencida como vigente.
    cohorte: Date.now() > Date.parse('2026-11-18T23:59:59-03:00') ? null : {
      lugares: 5,
      fechas: '5 lugares · inscripción hasta el 18/11 · arranca el 25/11',
      titulo: 'Cohorte fundadora',
      gana: ['Garantía: si a los 30 días tu equipo no usa sus tareas, seguimos sin cargo hasta el día 60.'],
      pide: 'A cambio, tu testimonio al día 30.',
    },
    precio: null, // la ficha dice «[precio]»
    // Sin la nota de licencias en la oferta general (An, 04/11: «si hace falta algo, lo decimos en cada cosa, no
    // en la general»).
    boton: 'Quiero mi lugar en la cohorte fundadora', // An, 04/11
  },
  ENERGIA: {
    titulo: 'Agencia · Plan Energía',
    bajada: 'La IA como motor de tu empresa.', // An, 04/11
    incluye: [ // §20A
      'Ves cómo funciona tu empresa entera: la operación mapeada, área por área',
      'Cada área con su agente y sus tareas, avanzando sin que la empujes',
      'Cada proceso escrito y una persona responsable adentro: la empresa no depende de vos',
    ],
    garantia: null,
    escasez: null,
    precio: 'Se cotiza según la empresa.', // §20A
    boton: 'Quiero postularme', // An, 04/11
  },
};

// El agendador (An, 04/11: «USA EL AGENDADOR»): la página de reservas de Google Calendar «Charla de 20 minutos con
// GUIA», creada el 04/11 por la sesión de la TV del stand (lun a vie de 11 a 13, Meet o llamada). Va el link directo:
// el atajo /agendar vive en public/_redirects de la rama de la TV. 🟠 Ninguna de las dos páginas cobra: el pago de
// la sesión de 1 hora se arregla aparte.
const AGENDADOR = 'https://calendar.app.google/FJuz4QLo2BAFW6AE9';
// La sesión de 1 hora (consultoría o taller 1 a 1), creada el 04/11 en el calendar de GUIA: lun, mar y vie 11 o 12;
// mié 14; jue 11, 12 o 18; una reserva por día; Meet; el formulario pregunta si es consultoría o taller.
const RESERVA_HORA = 'https://calendar.app.google/MpnyxsJT1jjMNbjh8';

// Cómo se combina cada pieza (An, 04/11: «son 3 productos, todo puede estar junto o los podés comprar por
// separado, es modular, tipo lego»). 🟠 Textos míos, a validar por An.
const COMBINA = {
  ia: 'Es la base: le sumás Tareas y Agentes cuando quieras.',
  habilidades: 'Va sola o dentro de tu Agencia.',
  agentes: 'Va solo o se suma a tu Agencia.',
};

const PUENTE_IA = 'Con tu agencia, esa tarea queda armada con la memoria de tu empresa y se transforma en una estrategia estable para escalar.'; // ficha v2; An, 04/11: «en vez de "sale igual cada vez"»

export const OFERTAS = {
  // Sin «combina» en la oferta de Agencia (04/11, «sábana»): que se compran sueltos o juntos ya lo dice la apertura.
  // Con «Persona», el primer punto del Plan Inicial habla de cómo trabaja la persona, no de una empresa (revisión 05/11).
  ia: ({ nivel, personal }) => {
    const base = NIVELES[nivel] || NIVELES.ASISTENCIA;
    const incluye = personal && base === NIVELES.INICIAL
      ? ['Desde el primer día conoce cómo trabajás, dónde están tus cosas y qué no se toca', ...base.incluye.slice(1)]
      : base.incluye;
    return { ...base, incluye, puente: PUENTE_IA };
  },
  habilidades: ({ habilidad, personal }) => ({
    titulo: 'Tareas',
    combina: COMBINA.habilidades,
    puente: 'Como tarea armada, sale como lo hace tu empresa y se transforma en una estrategia estable para escalar.', // An, 04/11
    bajada: habilidad && habilidad !== 'Otra' ? `${habilidad}: resuelto cada vez que lo pidas.` : 'Ese trabajo que se repite, resuelto cada vez que lo pidas.',
    // 🟠 míos, de la definición de Tareas (§22): a validar por An. Revisión 05/11: con qué se arma y cómo se pide
    // lo dice la banda de arriba; acá queda lo que hacemos nosotros.
    incluye: [
      'Tu tarea, armada por nosotros',
      personal ? 'La probamos con vos hasta que sale como la hacés' : 'La probamos con vos hasta que sale como la hace tu empresa',
    ],
    garantia: null,
    escasez: null,
    precio: null,
    boton: 'Quiero postularme', // An, 04/11
  }),
  agentes: () => ({
    titulo: 'Agentes',
    // Sin bajada (revisión 05/11): repetía el titular de la banda de arriba («un área … sin que la tengas que empujar»).
    combina: COMBINA.agentes,
    puente: 'Hoy lo hacés vos. Un agente toma esa área entera y la resuelve.', // línea del producto
    // An, 04/11: las tareas que se le asignan al agente son el producto Tareas. El agente y sus tareas se
    // compran por separado, y las tareas de un agente son de su área: no se mezclan áreas.
    // 🟠 míos, de la estructura de An (§22): a validar. Revisión 05/11: las áreas y el contexto ya los dice la banda;
    // «Con las tareas» se leía como incluidas, y la nota dice que se suman por separado.
    incluye: [
      'Un agente para el área que elijas',
      'Las tareas de esa área, armadas por nosotros',
    ],
    nota: 'El agente y sus tareas se suman por separado, y cada tarea es de su área.', // An, 04/11 (§22)
    garantia: null,
    escasez: null,
    precio: null,
    boton: 'Quiero postularme', // An, 04/11
  }),
  scan: () => ({
    titulo: 'Scan',
    puente: 'Esto mide una tarea. El Scan mira cómo trabaja tu empresa entera.', // línea del producto
    bajada: 'Sabés dónde se te va el tiempo y por dónde empezar.', // 🟠 mío
    incluye: [ // 🟠 míos, de lo que dijo Ricardo del Scan (§21): a validar
      'Un recorrido por cómo trabaja tu empresa hoy, área por área',
      'Dónde se pierde tiempo y qué se puede resolver con IA',
      'Un orden claro: qué hacer primero',
    ],
    garantia: null,
    escasez: null,
    precio: null,
    boton: 'Quiero postularme', // An, 04/11
  }),
  // An, 04/11: «explicalo como talleres de preguntas y respuestas … qué no es: un curso, una asesoría particular
  // (podés complementar). SEAMOS ESPECÍFICOS EN LA OFERTA». Reemplaza la oferta de talleres-ia/README.md.
  capacitaciones: () => ({
    titulo: 'Capacitaciones IA',
    bajada: 'Salís sabiendo cómo usar la IA para lo tuyo.', // 🟠 resultado, mío; «talleres de preguntas y respuestas» ya va arriba
    // Dos formatos lado a lado, cada uno con su botón (An, 04/11: «es tan fea la página de las capacitaciones»).
    formatos: [
      { nombre: 'Workshop grupal', detalle: ['Cada 15 días, en grupo', 'Traés tu pregunta y la exploramos juntos'], // An, 04/11: sin horarios ni cantidad por día en ningún lado
        accion: { texto: 'Anotarme', url: waLink('Hola Antonela, quiero anotarme al próximo workshop de preguntas y respuestas sobre IA.') } },
      { nombre: 'Taller 1 a 1', detalle: ['Una hora virtual, solo con vos', 'Sobre tu problema'], precio: '$99.000',
        accion: { texto: 'Reservar', url: RESERVA_HORA } },
    ],
    ejemplosTitulo: 'Qué podés traer',
    ejemplos: ['¿Cómo uso la IA en mi trabajo?', '¿Cuál me conviene para esto?', '¿Para qué sirve esta herramienta?', 'Quiero resolver esto.', 'Probé esto y no me salió.'],
    nota: 'Si traés una herramienta que no conocemos, la exploramos juntos.', // An, 04/11: «eso no va en la pregunta»
    noEs: 'No es un curso: no hay programa ni clases. Tampoco una asesoría particular: para eso está la consultoría, y se pueden complementar.',
    garantia: null,
    escasez: null,
    precio: null,
  }),
  consultoria: () => ({ // An, 04/11: reservar horas con ella; ya no hace webs ni sistemas
    titulo: 'Consultoría tech',
    bajada: 'Salís con tu caso pensado y un camino claro. Horas con Antonela.', // 🟠 resultado, mío
    formatos: [
      { nombre: 'Primer contacto', detalle: ['20 minutos por videollamada', 'Para asesorarte sobre los productos de GUIA'],
        accion: { texto: 'Agendar', url: AGENDADOR } },
      // Sin horarios ni cantidad por día (An, 04/11: «yo manejo mis horarios como quiero»): los resuelve la página de reserva.
      { nombre: 'Sesión de consultoría', detalle: ['1 hora por videollamada, sobre lo que necesites resolver'], precio: '$99.000',
        accion: { texto: 'Reservar', url: RESERVA_HORA } },
    ],
    garantia: null,
    escasez: null,
    precio: null,
  }),
};

// `datos`: { nivel, habilidad } (el nivel lo sugiere planes.js; la habilidad es la que eligió en hab_q1).
export { AGENDADOR };

export const ofertaPara = (producto, datos = {}) => (OFERTAS[producto] ? OFERTAS[producto](datos) : null);

// Lo que cambia con cada producto, antes de verlo andando. Vende el resultado, no describe el producto (An,
// 04/11: «le falta intro, ser más explícitos» y después «el qué es no era así, nos habíamos planteado vender el
// resultado»): titular con el resultado y tres resultados en fila; el cómo queda dicho debajo de cada uno.
// Estructura de An (oferta-de-productos.md §22): agencia → agentes por área → tareas. Sin «Claude» (§21d).
// 🟠 Textos míos, a validar por An.
// La diferencia con hacerlo uno mismo con un chat de IA, con lo que ya trabajó An (04/11: «ya está trabajado eso,
// no estás basándote en la info»). Fuentes:
// - REMAX, 03/11 (pitch-aios-preguntas-y-objeciones.md, objeción 1; transcripción «Nueva grabación 37», l. 884–905):
//   lo que mejor pegó fue «lo que tenés hoy depende de la capacidad tecnológica de una persona» y «esto te baja el
//   molde basado en lo que ya se trabajó en toda la oficina… te deja unos pasos más adelante»; además «la misma
//   respuesta siempre» y «un sistema centralizado en la oficina» (l. 722–753). La metáfora de la casa no convenció:
//   no va.
// - Ricardo, 03/11 (oferta-de-productos.md §21b–c): «un corset para la IA: le da forma, la encausa» · «al mismo
//   input, el mismo output» · objeción «me compro la habilidad y le pido a Claude que haga una».
// - REMAX, propuesta del 03/11: «los datos de la oficina en cuentas de la oficina, con quién ve qué definido».
// 🟠 La redacción es mía sobre esas frases, a validar por An.
const QUE_ES = {
  // Texto de An (04/11): «Agencia dirige y ejecuta. Incorporá las tareas que tu equipo puede automatizar. Dale
  // seguimiento. Consultá desde el celular.» Y la frase que pidió visible: «IA que no depende de quién la use para
  // entregar valor, sino que da valor a quien la usa» (resume la respuesta de REMAX de arriba).
  // Composición (04/11, An: «está llena de palabras… es una sábana total»): sin volanta ni segundo titular. El
  // titular de la banda es la frase de An; «sabe qué hacer» ya lo dice el titular de arriba.
  ia: (personal) => ({
    titulo: 'IA que no depende de quién la use para entregar valor, sino que da valor a quien la usa.',
    celular: true, // las tres partes manejan el mockup del celular (AgenciaCelular)
    partes: [
      [personal ? 'Incorporá las tareas que podés automatizar.' : 'Incorporá las tareas que tu equipo puede automatizar.', null],
      ['Dale seguimiento.', null],
      ['Consultá desde el celular.', null],
    ],
    // «Saber más» (An, 04/11): abre la respuesta ya trabajada en REMAX y con Ricardo (ver arriba). Cuando esté el
    // catálogo de tareas va acá un video corto (An, 04/11: «agregá un videito en agencia cuando esté el catálogo»).
    masTitulo: 'Saber más',
    // La definición de An (04/11), sin «siempre» (la IA no responde idéntico; el sistema le da forma):
    masIntro: 'Agencia es un sistema que hace que la IA no dependa de quién la usa para dar el mismo valor, y que suma valor a quien la usa.',
    mas: personal ? [
      ['Arrancás unos pasos más adelante', 'Te dejamos el molde armado con lo que ya te funciona: no hay que explicarle cada vez.'],
      ['Al mismo pedido, el mismo resultado', 'Le da forma a la IA: sigue tu manera de hacer las cosas, aunque cambie el modelo.'],
      ['Tus datos, en tus cuentas', 'Todo queda en cuentas tuyas, no en un chat suelto.'],
    ] : [
      ['No depende de una persona', 'Te bajamos el molde con lo que ya funciona en tu empresa: cada puesto arranca unos pasos más adelante.'],
      ['Al mismo pedido, el mismo resultado', 'Le da forma a la IA: sigue la manera de trabajar de tu empresa, aunque cambie el modelo.'],
      ['Los datos de tu empresa, en cuentas de tu empresa', 'Un sistema central, con quién ve qué definido.'],
    ],
  }),
  // Revisión 05/11: «a la medida de tu empresa» salía tres veces seguidas (titular de arriba, este titular y la
  // primera parte), y «lo armamos nosotros» se repetía en la oferta: acá queda lo que cambia; en la oferta, lo que hacemos.
  habilidades: () => ({
    volanta: 'Lo que cambia con Tareas',
    titulo: 'Al mismo pedido, el mismo resultado.',
    // La entrada al catálogo, en la mitad que quedaba vacía (An, 05/11: «este hueco gigante podrías poner un ingreso al
    // catálogo de tareas, un preview y una explicación, algo que den ganas de entrar»). 🟠 Textos míos, a validar.
    catalogo: { tareas: ['ventas', 'resenas', 'pedidos'], titulo: 'Ocho tareas ya armadas', texto: 'Cada una con su video: mirá cómo la hace y elegí con cuál empezar.' },
    partes: [
      ['Se arma una vez', 'Con tus datos, tus reglas y tu tono.'],
      ['Una estrategia estable para escalar', 'No depende de quién la pida ni de cómo lo escriba.'],
      ['La pedís en una frase', 'Te llega lista para aprobar.'],
    ],
  }),
  agentes: (personal) => ({
    volanta: 'Lo que cambia con Agentes',
    catalogo: { tareas: ['avisos', 'cotizar', 'agenda'], titulo: 'Un agente por área', texto: 'Mirá qué tareas sabe hacer cada agente, con su video, y elegí por dónde empezar.' }, // 🟠 mío
    titulo: personal ? 'Un área de tu trabajo avanzando sin que la tengas que empujar.' : 'Un área entera de tu empresa avanzando sin que la tengas que empujar.',
    partes: [
      ['El área responde', personal ? 'Tus pagos, tus consultas o tus ventas: el agente resuelve lo de todos los días.' : 'Administración, atención o ventas: el agente resuelve lo de todos los días.'],
      ['Con todo el contexto', 'Conoce las tareas, los clientes y las reglas de su área.'],
      ['El control es tuyo', 'Nada sale sin tu aprobación, y todo queda registrado.'],
    ],
  }),
};

export const queEsPara = (producto, collected = {}) => (QUE_ES[producto] ? QUE_ES[producto](collected.para === 'personal') : null);
